var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html(response.msg);
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

$(document).ready(function () {
  var elements = document.querySelectorAll('.js-gallery');
  if(elements && elements.length>0){
    for(var i=0;i<elements.length;i++){
        $(".js-gallery").eq(i).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Ładowanie #%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: 'Zamknij',
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: 'Poprzednie',
                tNext: 'Następne',
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
            },
            image: {
                tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    }
  }
});

$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {
    var el = $('[data-cookies]');

    $('[data-closecookies]').on('click', function () {
        el.fadeOut();
        Cookies.set('cookies_info', '1', {expires: 12});
    });

    var myCookie = Cookies.get('cookies_info');
    if (myCookie === undefined) {
        el.show();
    }
});
$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
      $(this).find('a').append('<span class="mobileMenu__submenuSwitcher"></span>');
    }
  });
  

  function submenuSwitcher() {
    $("[data-menu] .mobileMenu__submenuSwitcher").on("click", function (e) {
        if ($(e.target).hasClass('mobileMenu__submenuSwitcher')) {
          e.preventDefault();
          var el = $(this).parent();
          el.toggleClass("actived");
          el.next('ul').toggleClass("opened");
        }
    });
  }
  submenuSwitcher();

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});

if ($('.js-slider').length > 0) {
// main slider
  var $slider = $('.js-slider');

  function myHandler() {
    $slider.slick('slickPlay');
  }

  function playVideoSlide(slick, currentSlide, mute) {

    var slide = $(slick.$slides.get(currentSlide));
    if (slide.find('video').length) {
      if (slide.find('video')[0].readyState >= 2) {

        if (typeof mute !== "undefined")
          slide.find('video')[0].muted = true;
        else
          slide.find('video')[0].muted = false;

        slide.find('video')[0].play();
        $slider.slick('slickPause');

      } else {
        slide.find('video')[0].oncanplay = function () {
          if (typeof mute !== "undefined")
            slide.find('video')[0].muted = true;
          else
            slide.find('video')[0].muted = false;
          slide.find('video')[0].play();
          $slider.slick('slickPause');
        }
      }

      slide.find('video')[0].addEventListener('ended', function () {
        myHandler;
        $slider.slick('slickNext');
      }, false);
    }
  }

  $slider.on('init reInit', function (event, slick) {
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
    playVideoSlide(slick, 0, 1);
  });
  $slider.on('afterChange', function (event, slick, currentSlide) {
    var slide = $(slick.$slides.get(currentSlide));
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
    playVideoSlide(slick, currentSlide, 1);

    if (!slide.find('video').length) {
      $slider.slick('slickPlay');
    }

    $('.slick-dots li').removeClass('custom-active-class');
    $('.slick-dots li').eq(currentSlide).addClass('custom-active-class');
  });
  $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var slide = $(slick.$slides.get(currentSlide));
    if (slide.find('video').length) {
      slide.find('video')[0].pause();
    }
  });

  $slider.slick({
    arrows: true,
    speed: 700,
    autoplaySpeed: 7000,
    lazyLoad: 'progressive',
    dots: true,
    infinite: true,
    autoplay: true,
    // adaptiveHeight: true -> for videos
  });

// slider dots
  $slider.find('.slick-dots').append('<li class="hover-background"></li>');

  function updateBackground(target, $dots) {
    var pos = target.position();
    var width = target.outerWidth();

    $dots.find('.hover-background').css({
      left: pos.left,
      width: width
    });
  }

  var $initialActiveDot = $slider.find('.slick-dots li.slick-active');
  if ($initialActiveDot.length > 0) {
    updateBackground($initialActiveDot, $slider.find('.slick-dots'));
  }

  $slider.on('afterChange', function(event, slick, currentSlide){
    updateBackground($slider.find('.slick-dots li.slick-active'), $slider.find('.slick-dots'));
  });

  $slider.find('.slick-dots li').hover(function() {
    updateBackground($(this), $slider.find('.slick-dots'));
  }, function() {
    updateBackground($slider.find('.slick-dots li.slick-active'), $slider.find('.slick-dots'));
  });

}

 // imageslider
 var elements = document.querySelectorAll('.js-sliderGallery');
 if ( elements.length>0){
   $('.js-sliderGallery').slick({
       arrows: true,
       speed: 700,
       autoplaySpeed: 7000,
       dots: true,
       infinite: true,
       autoplay: true,
       slidesPerRow: 5,
       rows: 2,
       responsive: [
         {
           breakpoint: 678,
           settings: {
             slidesPerRow: 2,
             rows: 2,
           }
         }
       ]
   });
 }
// scrolledGallery for mobiles
let scrolledGallery = function() {
    $('.js-scrolledGallery').slick({
        arrows: true,
        speed: 700,
        fade: true,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              dots: false
            }
          }
        ]
    });
}
if ($(window).width() < 600) {
    scrolledGallery();
}
$(window).on('resize', function(){
    if ($(window).width() < 600) {
        scrolledGallery();
    }
});
//offerSlider
var element = document.querySelector('.js-offerSlider');
if ( $('.js-offerSlider').length ){
  $('.js-offerSlider').slick({
      arrows: true,
      speed: 1400,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 800,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              fade: false
          }
        },
        {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              fade: true
          }
        }
      ]
  });
}

//logoSlider
if ( $('.js-logoSlider').length ){
  $('.js-logoSlider').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 900,
          adaptiveHeight: false,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          adaptiveHeight: true,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }
      ]
  });
}
//productSlider
if ( $('.js-productSlider').length ) {

  var $slider2 = $('.js-productSlider');

  $slider2.on('init reInit', function (event, slick) {
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
  });
  $slider2.on('afterChange', function (event, slick, currentSlide) {
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');


    $('.slick-dots li').removeClass('custom-active-class');
    $('.slick-dots li').eq(currentSlide).addClass('custom-active-class');
  });


  $('.js-productSlider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      dots: false,
      infinite: true,
      autoplay: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
  var count = $('.js-productSlider .slick-slide').length;
  if (count > 1 && $(window).width() > 1239) {
    $('.js-productSlider').slick('slickSetOption', 'dots', true, true);


  // slider dots
  $('.slick-dots').append('<li class="hover-background"></li>');

  function updateBackground(target) {
    var pos = target.position();
    var width = target.outerWidth();

    $('.slick-dots .hover-background').css({
      left: pos.left,
      width: width
    });
  }

  updateBackground($('.slick-dots li.slick-active'));

  $slider2.on('afterChange', function (event, slick, currentSlide) {
    updateBackground($('.slick-dots li.slick-active'));
  });

  $('.slick-dots li').hover(function () {
    updateBackground($(this));
  }, function () {
    updateBackground($('.slick-dots li.slick-active'));
  });
  }
}

// 2 sliders - app subpage
if ( $('.appSliders__text').length ) {
  $('.appSliders__text').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    asNavFor: '.appSliders__img',
    responsive: [
      {
        breakpoint: 900,
        settings: {
          autoplay: true
        }
      }
    ]
  });

  // slider dots
  $('.appSliders__text').find('.slick-dots').append('<li class="hover-background"></li>');

  function updateBackground(target, $dots) {
    var pos = target.position();
    var width = target.outerWidth();

    $dots.find('.hover-background').css({
      left: pos.left,
      width: width
    });
  }

  var $initialActiveDot2 = $('.appSliders__text').find('.slick-dots li.slick-active');
  if ($initialActiveDot2.length > 0) {
    updateBackground($initialActiveDot2, $('.appSliders__text').find('.slick-dots'));
  }

  $('.appSliders__text').on('afterChange', function(event, slick, currentSlide){
    updateBackground($('.appSliders__text').find('.slick-dots li.slick-active'), $('.appSliders__text').find('.slick-dots'));
  });

  $('.appSliders__text').find('.slick-dots li').hover(function() {
    updateBackground($(this), $('.appSliders__text').find('.slick-dots'));
  }, function() {
    updateBackground($('.appSliders__text').find('.slick-dots li.slick-active'), $('.appSliders__text').find('.slick-dots'));
  });
}


if ( $('.appSliders__img').length ) {
  $('.appSliders__img').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.appSliders__text',
    dots: false,
    arrows: true,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
          autoplay: true,
          slidesToShow: 1
        }
      }
    ]
  });
}

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
$(document).ready(function(){

  // go to form message
  if ( $('.formErrors__item').length ) {
    $('html, body').animate({
        scrollTop:  $('.formErrors__item').first().offset().top - 200
    }, 600);
  }

  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');
        $('.languageBox').toggleClass('active');
        return false;
    });
  }

  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500
      });
  }

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad();
    observer.observe();
  }

  // Handle Lazy loading on page print
  window.onbeforeprint = function() {
    $('.lozad').each(function() {
      var src = $(this).attr('data-src');
      $(this).attr('src', src).parent().addClass('loaded');
    });
  };

  // scrolled menu
  if ($(window).width()<1240){
          $('.js-header').addClass('header--scrolled');
  } else {
      $('.js-header').removeClass('header--scrolled');
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });


  // scrolled menu
  if ($(window).scrollTop() > 0) {
    $('.js-header').addClass('header--scrolled');
    if ($('.hamburger--2').length) {
      $('.hamburger--2').on("click", function () {
        //$(this).toggleClass('active');
        $('.header--3').removeClass('header--scrolled');
      });
    }
  } else {
    if ( $(window).width()>1240 && $('.hamburger--2').length==0 ){
      $('.js-header').removeClass('header--scrolled');
    }
  }

  //search
  $('.js-header__search').on('click', function(){
      $('.header .header__searchBox form').toggleClass('header__searchBoxForm--hidden');
      $('.header .header__searchBox').slideToggle(300);
  });
  $('.js-header__searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });
  $('.js-closeSearch').on('click', function(){
    $('.header .header__searchBox form').addClass('header__searchBoxForm--hidden');
    $('.header .header__searchBox').slideUp(300);
  });

  //login
  if($('body').hasClass('user-logged')) {
    $('.header__loginBox').on('click', function() {
      $('.loginList').slideToggle('fast');
      return false;
    });
  }
  
}); // end document ready

$(window).on('load', function(){

});

$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 } else {
  if ($(window).width()>1240){
    $('.js-header').removeClass('header--scrolled');
  }
}

}); // end onscroll


var a = 0;
$(window).scroll(function () {
  if ($("#counter-box").length) {
    var oTop = $("#counter-box").offset().top - window.innerHeight;
    if (a == 0 && $(window).scrollTop() > oTop) {
      $(".counter").each(function () {
        var $this = $(this),
          countFrom = $this.attr("data-start") || 0,
          countTo = $this.attr("data-number");

        $({
          countNum: parseInt(countFrom)
        }).animate(
          {
            countNum: parseInt(countTo)
          },

          {
            duration: 4000,
            easing: "swing",
            step: function () {
              $this.text(
                Math.ceil(this.countNum).toLocaleString("pl", { useGrouping: false })
              );
            },
            complete: function () {
              $this.text(
                Math.ceil(this.countNum).toLocaleString("pl", { useGrouping: false })
              );
            }
          }
        );
      });
      a = 1;
    }
  }
});

function videoPlay(wrapper) {
  var iframe = wrapper.find('.js-videoIframe');
  var src = iframe.data('src');
  wrapper.addClass('videoWrapperActive');
  iframe.attr('src',src);
}
//YOUTUBE VIDEO
$('.js-videoPoster').click(function(){
  var iframeEl = $('<iframe>', { src: $(this).data('url') });
  $('.videoIframe').attr('src', $(this).data('url'));
  $('.youtube-video .modal-dialog').css("display","flex");
  $('body').addClass('stop');
})

$('#close-video').click(function(){
  $('.videoIframe').attr('src', '');
  $('.youtube-video .modal-dialog').css("display","none");
  $('body').removeClass('stop');
});

$(document).on('hidden.bs.modal','#myModal', function () {
  $('.videoIframe').attr('src', '');
});

$(document).on('click', '.youtube-video .modal-dialog', function(event) {
  var $target = $(event.target);
  if (!$target.closest('.modal-content').length) {
    $('.videoIframe').attr('src', '');
    $('.youtube-video .modal-dialog').css("display", "none");
    $('body').removeClass('stop');
  }
});

$(document).on('click', '.youtube-video .modal-content', function(event) {
  event.stopPropagation();
});

//# sourceMappingURL=front.js.map
